import { Controller } from '@hotwired/stimulus';

// Segmented Production/Sandbox control that filters the generations table rows
// client-side. Each row carries data-env; the empty target shows when the
// active environment has no rows.
export default class extends Controller {
  static targets = ['button', 'row', 'empty'];
  static values = { env: { type: String, default: 'production' } };

  connect() {
    this.apply();
  }

  select(event) {
    this.envValue = event.currentTarget.dataset.env;
  }

  envValueChanged() {
    this.apply();
  }

  apply() {
    this.buttonTargets.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.env === this.envValue);
    });

    let visible = 0;
    this.rowTargets.forEach((row) => {
      const show = row.dataset.env === this.envValue;
      row.hidden = !show;
      if (show) visible += 1;
    });

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0;
  }
}
